.overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.visible {
  opacity: 1;
  pointer-events: auto;
}

.icon {
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  fill: rgba(255, 255, 255, 0.8);
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 6px;
}

.message {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}
